"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _remove = require("../../../../assets/icons/remove.svg");
var _file = require("../../../../assets/icons/file.svg");
var _format = require("../../../../utils/files/format");
var _fileItemModule = _interopRequireDefault(require("./file-item.module.scss"));
var FileItem = function FileItem(_ref) {
  var file = _ref.file,
    onRemoveClick = _ref.onRemoveClick;
  var fileSize = (0, _format.formatFileSize)(file.size);
  var handleRemoveClick = (0, _react.useCallback)(function () {
    return onRemoveClick(file);
  }, [onRemoveClick, file]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _fileItemModule.default['file-item']
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _fileItemModule.default['file-item__file-name-container']
  }, /*#__PURE__*/_react.default.createElement(_file.ReactComponent, {
    className: _fileItemModule.default['file-item__file-icon']
  }), "".concat(file.name, " (").concat(fileSize, ")")), /*#__PURE__*/_react.default.createElement(_remove.ReactComponent, {
    className: _fileItemModule.default['file-item__remove-icon'],
    onClick: handleRemoveClick,
    "data-testid": "remove-file-icon"
  }));
};
exports.FileItem = FileItem;